import type { SessionKeyData } from '@polaris/core/models'
import { connectLitClient, litClient } from '@polaris/core/mpc'
import { deriveNamadaKeys } from '@polaris/core/namada'
import { queryOptions } from '@tanstack/react-query'
import { scanPrivacyFunds } from '@/src/services/mpc'

const SCAN_PRIVACY_FUNDS_QUERY_KEY = 'privacy-funds'
const MPC_NAMADA_KEYS_QUERY_KEY = 'namada-keys'

export const getScanPrivacyFundsQuery = (
  routeId: string,
  sessionKeyData: SessionKeyData | undefined,
) =>
  queryOptions({
    queryKey: ['mpc', SCAN_PRIVACY_FUNDS_QUERY_KEY, routeId],
    queryFn: () =>
      scanPrivacyFunds({
        routeId,
        sessionKeyData: sessionKeyData!,
      }),
    enabled: !!sessionKeyData,
  })

/**
 * Query options for deriving Namada keys from MPC session data
 * Returns pseudoExtendedKey and other derived keys needed for privacy routes
 */
export const getMpcNamadaKeysQuery = (
  sessionKeyData: SessionKeyData | undefined,
  enabled = true,
) =>
  queryOptions({
    queryKey: ['mpc', MPC_NAMADA_KEYS_QUERY_KEY, sessionKeyData],
    queryFn: async () => {
      if (!sessionKeyData) {
        throw new Error('Session key data is required')
      }
      await connectLitClient()
      return deriveNamadaKeys(litClient, sessionKeyData)
    },
    enabled: !!sessionKeyData && enabled,
    staleTime: Infinity, // Never mark as stale
    gcTime: Infinity, // Never garbage collect from cache
    retry: 1,
  })
